"use client"

import { useState } from "react"
import { Button } from "@/components/ui/button"
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog"
import { cn } from "@/lib/utils"

const PREVIEW_MAX = 2

export function ConnectionBenefitsCell({
  lines,
  contextLabel,
  className,
}: {
  lines: string[]
  /** Shown under the modal title (e.g. organization name). */
  contextLabel?: string
  className?: string
}) {
  const [open, setOpen] = useState(false)
  if (lines.length === 0) {
    return <span className="text-muted-foreground text-xs">—</span>
  }
  const preview = lines.slice(0, PREVIEW_MAX)
  const hasMore = lines.length > PREVIEW_MAX
  return (
    <>
      <div className={cn("text-[10px] space-y-1 min-w-0", className)}>
        {preview.map((line, i) => (
          <div key={i} className="text-foreground break-words" title={line}>
            {line}
          </div>
        ))}
        {hasMore ? (
          <Button
            type="button"
            variant="link"
            className="h-auto p-0 text-[10px] text-blue-600 leading-tight"
            onClick={() => setOpen(true)}
          >
            View more
          </Button>
        ) : null}
      </div>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="sm:max-w-md">
          <DialogHeader>
            <DialogTitle>Sponsorship benefits</DialogTitle>
            {contextLabel ? <DialogDescription>{contextLabel}</DialogDescription> : null}
          </DialogHeader>
          <ul className="list-none space-y-2 text-sm text-foreground">
            {lines.map((line, i) => (
              <li key={i} className="flex gap-2">
                <span className="text-emerald-600 shrink-0">•</span>
                <span className="min-w-0 break-words">{line}</span>
              </li>
            ))}
          </ul>
        </DialogContent>
      </Dialog>
    </>
  )
}
